var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthenticationService } from '@app/core';
import { AnimatedModalComponent } from '@app/shared/modals/animated-modal.component';
var GuestModalTimedComponent = /** @class */ (function (_super) {
    __extends(GuestModalTimedComponent, _super);
    function GuestModalTimedComponent(ref, formBuilder, auth, elRef, renderer) {
        var _this = _super.call(this, elRef, renderer) || this;
        _this.ref = ref;
        _this.formBuilder = formBuilder;
        _this.auth = auth;
        _this.elRef = elRef;
        _this.renderer = renderer;
        _this.loading = false;
        _this.errors = null;
        _this.form = _this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
        });
        return _this;
    }
    GuestModalTimedComponent.prototype.submit = function () {
        var _this = this;
        this.auth.guestTimed = true;
        if (!this.loading) {
            this.loading = true;
            this.auth.regEmail(this.form.get('email').value).subscribe(function (result) {
                _this.loading = false;
                _this.auth.guestEmail = _this.form.get('email').value;
                _this.close();
            }, function (e) {
                _this.loading = false;
                _this.errors = 'Check your email and try again.';
            });
        }
    };
    GuestModalTimedComponent.prototype.close = function () {
        this.auth.guestTimed = true;
        this.auth.guestEmail = this.form.get('email').value;
        this.ref.close();
    };
    GuestModalTimedComponent.prototype.reject = function () {
        this.auth.guestTimed = true;
        this.ref.dismiss();
    };
    return GuestModalTimedComponent;
}(AnimatedModalComponent));
export { GuestModalTimedComponent };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/guest-modal-timed.component.ts.pre-build-optimizer.js